import React from "react";
import { Navigate } from "react-router-dom";

//------------------------------
// Pages Component
//------------------------------

// Authentication related pages
import Login from "../pages/Authentication/LoginTest";
import LoginTest from "../pages/Authentication/LoginTest";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import RegisterTest from "../pages/Authentication/RegisterTest";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import ResetPwd from "../pages/Authentication/ResetPassword";
import VerifyAcct from "../pages/Authentication/VerifyAccount";

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Login2 from "../pages/AuthenticationInner/Login2";
import Register1 from "../pages/AuthenticationInner/Register";
import Register2 from "../pages/AuthenticationInner/Register2";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";
import ForgetPwd2 from "../pages/AuthenticationInner/ForgetPassword2";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2";


// Dashboard
import Dashboard from "../pages/Dashboard/index";
import PurchasePoint from "../pages/Purchase-point/index";
import PurchasePointHistory from "../pages/Purchase-point-history/crypto-orders";



import AdminQuestionOptions from "../pages/Info/admin/AdminQuestionOptions";

// InfoInputs
import ChooseTheme from "../pages/Info/inputs/ThemeGrid";
import CollectionList from "../pages/Info/inputs/CollectionList";
import TopicList from "../pages/Info/inputs/TopicList";
import QuestionSetList from "../pages/Info/inputs/QuestionSetList/QuestionSetList";
import QuestionSetInput from "../pages/Info/inputs/QuestionSetInput/QuestionSetInput";
import QuestionSetRewards from "../pages/Info/inputs/QuestionSetInput/QuestionSetRewards";
import StoreMenu from "../pages/Info/storeMenu/StoreMenu";
import StoreContent from "../pages/Info/storeMenu/StoreContent/StoreContent";
import StoreTopic from "../pages/Info/storeMenu/StoreTopic/StoreTopic";

import InfoFeed from "../pages/Info/feed/InfoFeed";
import Feed from "../pages/Info/feed/Feed";

import InfoInput from "../pages/Info/inputs/InfoInput";
import InfoTopicInput from "../pages/Info/inputs/InfoTopicInput/InfoTopicInput";
import InfoQuestionForum from "../pages/Info/inputs/Forum/InfoQuestionForum";
import ChooseTopic from "../pages/Info/inputs/ChooseTopic";
import DiscoverSwipe from "../pages/Info/board/DiscoverSwipe";
import TownMap from "../pages/Info/inputs/TownMap";
import InfoProfile from "../pages/Info/profile/InfoProfile/InfoProfile";
import UserInfoTopicEditor from "../pages/Info/profile/topicEditor/UserInfoTopicEditor";
import UserInfoQuestionSetEditor from "../pages/Info/profile/questionSetEditor/UserInfoQuestionSetEditor";
import UserInfoQuestionEditor from "../pages/Info/profile/questionEditor/UserInfoQuestionEditor";

// InfoEditors
import InfoEditor from "../pages/Info/editors/InfoEditor";
import InfoThemeEditor from "../pages/Info/editors/InfoThemeEditor";
import InfoCollectionEditor from "../pages/Info/editors/InfoCollectionEditor";
import InfoTopicEditor from "../pages/Info/editors/InfoTopicEditor";
import InfoQuestionSetEditor from "../pages/Info/editors/InfoQuestionSetEditor/InfoQuestionSetEditor";
import InfoQuestionEditor from "../pages/Info/editors/InfoQuestionEditor/InfoQuestionEditor";
// CustomEditors
import CustomEditorCateList from "../pages/Info/customEditors/CustomEditorCateList";

// Bank - myInfoPoints
import PointsBankMain from "../pages/Info/points/BankMainPage";
import PointsRedemption from "../pages/Info/points/PointRedemption";
import InfoPointRecords from "../pages/Info/points/InfoPointRecords/InfoPointRecords";
import BankInfoSettings from "../pages/Info/points/BankInfoSettings";
// Bank - admin
import AdminBankInfoPage from "../pages/Info/points/AdminBankInfoPage";
import AdminRedemptionPage from "../pages/Info/points/AdminRedemptionPage";


const authProtectedRoutes = [


  /*---- Dashboard ----*/

  { path: "/dashboard", component: <Dashboard /> },

  { path: "/myInfo", component: <InfoInput />},
  { path: "/myInfo/testTopics/:infoTopicId", component: <InfoTopicInput /> },
  { path: "/myInfo/dashboard", component: <TownMap />},
  { path: "/myInfo/profile", component: <InfoProfile />},

  { path: "/myInfo/editTopic/:infoTopicId", component: <UserInfoTopicEditor />},
  { path: "/myInfo/editQuestionSet/:infoQuestionSetId", component: <UserInfoQuestionSetEditor />},
  { path: "/myInfo/editQuestion/:infoQuestionId", component: <UserInfoQuestionEditor />},

  { path: "/myInfo/navigateThemes", component: <ChooseTheme />},
  { path: "/myInfo/themes/:themeId", component: <CollectionList />},
  { path: "/myInfo/collections/:collectionId", component: <TopicList />},
  { path: "/myInfo/topics/:topicId", component: <QuestionSetList />},
  { path: "/myInfo/questionSets/:questionSetId", component: <QuestionSetInput />},
  { path: "/myInfo/questionSets/:questionSetId/redeemReward", component: <QuestionSetRewards />},
  { path: "/myInfo/questions/:questionId/discussions", component: <InfoQuestionForum />},
  
  { path: "/myInfo/storeMenu", component: <StoreMenu />},
  { path: "/myInfo/storeMenu/stores/:storeId", component: <StoreContent />},
  { path: "/myInfo/storeMenu/topics/:topicId", component: <StoreTopic />},

  { path: "/myInfo/infoFeed", component: <InfoFeed />},
  { path: "/myInfo/feed", component: <Feed /> },

  { path: "/myInfo/search", component: <InfoFeed />},

  { path: "/myInfo/questions/:infoQuestionId/manageOptions", component: <AdminQuestionOptions />},

  { path: "/myInfo/chooseTopic", component: <ChooseTopic />},
  { path: "/myInfo/discover", component: <DiscoverSwipe />},
  /*{ path: "/infoAdmin", component: <InfoAdmin />},*/
  { path: "/editInfoThemeList", component: <InfoEditor />},
  { path: "/editInfoThemes/:infoThemeId", component: <InfoThemeEditor />},
  { path: "/editInfoCollections/:infoCollectionId", component: <InfoCollectionEditor />},
  { path: "/editInfoTopics/:infoTopicId", component: <InfoTopicEditor />},
  { path: "/editInfoQuestionSets/:infoQuestionSetId", component: <InfoQuestionSetEditor />},
  { path: "/editInfoQuestions/:infoQuestionId", component: <InfoQuestionEditor />},
  
  { path: "/myInfo/createQuestionSets", component: <CustomEditorCateList />},

  { path: "/myInfo/pointsBank", component: <PointsBankMain />},
  { path: "/myInfo/pointsRedemption", component: <PointsRedemption />},
  { path: "/myInfo/pointsRecords", component: <InfoPointRecords />},
  { path: "/myInfo/bankInfoSettings", component: <BankInfoSettings />},
  { path: "/adminBankInfo", component: <AdminBankInfoPage />},
  { path: "/adminRedemptionManagement", component: <AdminRedemptionPage />},

  { path: "/purchase-point", component: <PurchasePoint /> },
  { path: "/purchase-point-history", component: <PurchasePointHistory /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/myInfo/storeMenu" />,
  },
];


const publicRoutes = [
  { path: "/login_test", component: <LoginTest />},
  { path: "/login", component: <Login /> },
  
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/reset-password/:token", component: <ResetPwd /> },
  { path: "/register_test", component: <RegisterTest /> },
  { path: "/register", component: <Register /> },
  { path: "/verify-account/:token", component: <VerifyAcct /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-login-2", component: <Login2 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/pages-register-2", component: <Register2 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/page-recoverpw-2", component: <Recoverpw2 /> },
  { path: "/pages-forgot-pwd", component: <ForgetPwd1 /> },
  { path: "/auth-recoverpw-2", component: <ForgetPwd2 /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/auth-lock-screen-2", component: <LockScreen2 /> },
  { path: "/page-confirm-mail", component: <ConfirmMail /> },
  { path: "/page-confirm-mail-2", component: <ConfirmMail2 /> },
  { path: "/auth-email-verification", component: <EmailVerification /> },
  { path: "/auth-email-verification-2", component: <EmailVerification2 /> },
  { path: "/auth-two-step-verification", component: <TwostepVerification /> },
  { path: "/auth-two-step-verification-2", component: <TwostepVerification2 /> },
];

export { authProtectedRoutes, publicRoutes };
